const ls = require("local-storage");
import ItensMenuService from "../services/ItensMenuService";

class ItensMenuUtilitario {
    constructor() {
        this.ItensMenu = this.loadItensMenuFromStorage();
    }

    // Helper to load menu items from local storage
    loadItensMenuFromStorage() {
        try {
            const storedData = ls.get('itensMenusPedagogico');
            return storedData ? JSON.parse(storedData) : [];
        } catch (error) {
            console.error('Error loading ItensMenu from local storage:', error);
            return [];
        }
    }

    async getItensByMenu(idMenu) {
        try {
            // Early return if ItensMenu is valid and contains data
            if (this.ItensMenu && this.ItensMenu.length > 0) {
                return this.ItensMenu.filter((item) => item.menu === idMenu);
            }
            await this.carregarItensMenu(); // Load menu items
            return this.ItensMenu.filter((item) => item.menu === idMenu); // Reapply the filter
        } catch (error) {
            console.error('Error fetching items by menu:', error);
            return [];
        }
    }

    async carregarItensMenu() {
        try {
            const role = ls.get('nivel_user'); // Fetch user role
            if (!role) {
                console.warn('User role not found in local storage.');
                return;
            }

            const response = await ItensMenuService.getItensMenuAll();
            const filteredItens = response.filter((obj) => {
                const niveis = obj.niveis.split(','); // Split levels by comma
                return niveis.includes(`${role}`); // Match user role
            });

            // Update local storage and instance variable
            this.ItensMenu = filteredItens;
            ls.set('itensMenusPedagogico', JSON.stringify(filteredItens));
        } catch (error) {
            console.error('Error loading menu items from service:', error);
        }
    }
}

export default new ItensMenuUtilitario();
